<template>
    
      <b-card>
        <b-row>
          <div style="position:absolute; top:10px; right:25px;">
            <span style="display:inline-block" class="mr-2">
              <b-form-select v-model="quotStatsFilters.salesRep" @change="onGetQuoteStatus" class="mb-2">
                <option :value="null"> -- All Sales Rep -- </option>
                <option v-for="(rep, i) in salesReps" :key="i" :value="rep.id">{{rep.name}} </option>
              </b-form-select>
            </span>
            <span style="display:inline-block">
              <b-form-select :value="quotStatsSelectedDateRange" @change="onDateRangeChange" class="mb-2 mr-2">
                <option :value="null">All</option>
                <option v-for="(type) in dateRangeTypes" :key="type" :value="type">  
                  {{type}}
                </option>
              </b-form-select> 
            </span>
          </div>
          <b-modal size="sm" title="Custom Date for Quote Status" id="custom-date-quot-stats" @ok="onCustomSet" no-close-on-backdrop>
            <div style="display:flex; flex-direction: row; justify-content: center; top: 0;">
              <!-- v-if="quotStatsSelectedDateRange === dateRangeTypes.CUSTOM" -->
            <b-form-group label="From"  class="mb-4 mr-2" >
              <date-picker v-model="quotStatsFilters.dateFrom" :config="datePickerOptions" size="sm" />
            </b-form-group>
            <b-form-group label="To" class="mb-4">
              <date-picker v-model="quotStatsFilters.dateTo" :config="datePickerOptions" size="sm" />
            </b-form-group>
            </div>          
          </b-modal>    
        </b-row>
        <br/>
        <div>
          <apex-chart chartType="donut" :chartOptions="chartOptions" :chartSeries="chartSeries" />
        </div>
      </b-card>  
</template>

<script>
  import ApexChart from './../extensions/ApexChart'
  import { ACTIVE, REQUEST_DATE, DATE_FORMAT, SEARCH_DEBOUNCE_TIME } from '@/shared/constants';
  import { getDatesFromRangeString, dateToDay, generateListofDates } from '@/shared/helpers';
  import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

  export default {
    components: {
      ApexChart
    },
    data () {
      return {
        dateRangeTypes: REQUEST_DATE,
        datePickerOptions: {
          format: DATE_FORMAT,
          useCurrent: false,
        },
        componentKey: 0,
        isLoadingWidget: true,
        chartOptions: {},
        chartSeries: [],
      }
    },
    computed: {
      ...mapGetters('account', ['userId']),
      ...mapState('salesReps', ['salesReps']),
      ...mapGetters('dashboard', ['quotStatsSelectedDateRange', 'quotStatsFilters']),
    }, 
    methods: {
      ...mapActions('dashboard', ['getQuoteStatus']),
      ...mapMutations('dashboard', ['setItem']),
      onDateRangeChange(value) { 
        if (value === REQUEST_DATE.CUSTOM) {
          this.quotStatsFilters.dateFrom = null;
          this.quotStatsFilters.dateTo= null;
          this.$bvModal.show('custom-date-quot-stats');
        } else if (value == null) {
          this.quotStatsFilters.dateFrom = null;
          this.quotStatsFilters.dateTo= null;
          this.onGetQuoteStatus();
        } else {
          const { dateFrom, dateTo } = getDatesFromRangeString(value);
          this.setDefaults();
          this.quotStatsFilters.dateFrom = dateFrom;
          this.quotStatsFilters.dateTo= dateTo;
          this.onGetQuoteStatus();
        }

        this.setItem({ resource: 'quotStatsSelectedDateRange', payload: value });
      },
      onCustomSet() {
        if (this.quotStatsFilters.dateFrom && this.quotStatsFilters.dateTo) {
          this.setDefaults();
          this.onGetQuoteStatus();
          
        }
        this.$bvModal.hide('custom-date-quot-stats');
      },
      async onGetQuoteStatus() {
        this.isLoadingWidget = true;

        await this.getQuoteStatus(this.quotStatsFilters).then((res) => { 
          let amountSeries = res.map(x => x.salesAmount)
          this.chartOptions = {
              ...this.chartOptions,
              noData: {
                  text: (res.length > 0) ? '' : 'No available data'
              },
              labels: res.map(x => x.statusName),
              plotOptions: {
                pie: {
                  donut: {
                    labels: {
                      show: true,
                      total: {
                        showAlways: true,
                        show: true
                      }
                    }
                  }    
                }
              },
              dataLabels: {
                enabled: true,
                formatter(val, opts) {
                  return [opts.w.globals.labels[opts.seriesIndex],opts.w.globals.series[opts.seriesIndex]];
                }
              }
              
          }
          this.chartSeries = res.map(x => x.statusCount)
          this.isLoadingWidget = false;
        });
      },
      setDefaults() {
          this.chartOptions = { 
            chart: {
                id: 'quote-statuses-donut',
                type: 'donut'
            },
            title: {
                text: 'Quotes Statuses'
            },
            noData: {
                text: 'Fetching data...'
            },
            colors: [function({ value, seriesIndex, w }) {
              if (w.globals.labels[seriesIndex] == 'Open') {
                 return '#008FFB'
              } else if (w.globals.labels[seriesIndex] == 'Closed') {
                return '#D7263D';
              } else if (w.globals.labels[seriesIndex] == 'Sold') {
                return '#00E396';
              } else {
                  return '#C4BBAF'
              }
            }],
            responsive: [
              {
                options: {
                  chart: {
                    width: 50
                  },
                  legend: { position: 'bottom'}
                }
              }
            ]
          };
          this.chartSeries = [];
      }
    },
    mounted () {
      if (this.quotStatsSelectedDateRange == REQUEST_DATE.CUSTOM)
        this.setItem({ resource: 'quotStatsSelectedDateRange', payload: REQUEST_DATE.THIS_YEAR });

      const { dateFrom, dateTo } = getDatesFromRangeString(this.quotStatsSelectedDateRange);
      this.setDefaults();
      this.quotStatsFilters.dateFrom = dateFrom;
      this.quotStatsFilters.dateTo= dateTo;
      this.onGetQuoteStatus();
    },
  }
</script>

<style>
  .small {
    max-width: 600px;
    margin:  150px auto;
  }
</style>